<div class="w-full h-full inline-block align-middle">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payment-ozow_eft.png" alt="ozow logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center" *ngIf="!confirmed"><b>Confirming Transaction Status</b></h3>
    </div>  
    <div class="flex justify-center pt-4 pb-8">
        <mat-spinner></mat-spinner>
    </div>
</div>